import { MutableRefObject, useEffect, useState } from "react";
import { AuctionPostbackStatus } from "../_common/models/auction/auctionPostbackStatus.model";
import { createResilientHubConnection } from "./signalRHub.helper";

export function useAuctionStatus(auctionId: number | null, rejoinRef?: MutableRefObject<(() => Promise<void>) | null>) {
    const [auctionStatus, setAuctionStatus] = useState<AuctionPostbackStatus | null>(null);
    const [connected, setConnected] = useState(false);

    useEffect(() => {
        if (!auctionId) return;

        return createResilientHubConnection({
            hubName: "auction",
            joinInvoke: {
                joinMethod: "JoinAuction",
                leaveMethod: "LeaveAuction",
                args: [auctionId],
            },
            rejoinRef,
            onConnectedChange: setConnected,
            registerHandlers: (conn) => {
                conn.on("AuctionStatusUpdated", (payload: { auctionPostbackStatus: AuctionPostbackStatus }) => {
                    if (payload?.auctionPostbackStatus?.auctionId === auctionId) {
                        setAuctionStatus({ ...payload.auctionPostbackStatus });
                    }
                });
            },
        });
    }, [auctionId]);

    return { auctionStatus, connected };
}
